import * as Sentry from '@sentry/react'

import { ENVIRONMENT } from 'constants/application'

import { isPreviewHost } from './isPreviewHost'

// Kept in its own module — and deliberately free of model/Redux/api-URL
// imports — so `src/index.tsx` can import it during the bootstrap phase
// without transitively evaluating `constants/API/apiURL.ts`, which reads
// `getRuntimeConfig()` at module load and would throw before
// `loadRuntimeConfig()` has resolved.

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
const BUILD_RELEASE = process.env.REACT_APP_SHORT_SHA

/**
 * Minimal Sentry init for the bootstrap phase, before `loadRuntimeConfig()`
 * resolves. Uses build-time DSN and environment so a failure in the runtime-
 * config fetch (broken ConfigMap, unreachable backend, etc.) still surfaces
 * as a Sentry event instead of a silent blank page.
 *
 * Skips heavyweight integrations (BrowserTracing, ExtraErrorData) because
 * the React tree isn't mounted yet and the routing instrumentation would
 * have nothing to bind to. `initSentry()` later replaces the config with
 * the full set of integrations once runtime config is loaded.
 */
export const initSentryEarly = () => {
  if (isPreviewHost()) return false
  if (!SENTRY_DSN) return false
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: BUILD_RELEASE,
    normalizeDepth: 10,
    maxBreadcrumbs: 10,
    tracesSampleRate: 0,
    ignoreErrors: [
      /Object Not Found Matching Id:\d+/gm,
    ],
  })
  return true
}
